import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import type { IHttpCall } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  FetchKaiserUrlPayloadDTO,
  FetchKaiserUrlResponseDTO,
} from './fetch-kaiser-url.types';

type FetchKaiserUrlOptions = {
  httpCall: IHttpCall;
  requestOverride?: Partial<IHttpRequest<FetchKaiserUrlPayloadDTO>>;
};

/**
 * Fetches the Kaiser URL from the API
 *
 * @param baseUrl - The base URL for the leads API
 * @param payload - The payload containing domainSessionId
 * @param options - Optional configuration for httpCall and request overrides
 * @returns Promise with the Kaiser URL response
 */
export function fetchKaiserUrl(
  baseUrl: string,
  payload: FetchKaiserUrlPayloadDTO,
  options?: FetchKaiserUrlOptions,
): Promise<IHttpResponse<FetchKaiserUrlResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<FetchKaiserUrlPayloadDTO> = {
    url: `${baseUrl}/api/v1/lead/btyp/cta/${payload.domainSessionId}`,
    method: 'GET',
    ...options?.requestOverride,
    schemas: {
      request: FetchKaiserUrlPayloadDTO,
      response: FetchKaiserUrlResponseDTO,
    },
  };

  return call(request);
}
